import React from "react";

interface ErrorBoundaryProps {
  children: React.ReactNode;
  resetKey?: string;
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps> {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught by ErrorBoundary:", error, errorInfo);
  }

  componentDidUpdate(previousProps: ErrorBoundaryProps) {
    if (this.state.hasError && previousProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) {
      return <section role="alert" style={{ padding: 24, maxWidth: 640 }}>
        <h2>Visningen kunne ikke vises</h2>
        <p>Det oppstod en uventet feil. Prøv igjen, eller last siden på nytt hvis feilen vedvarer.</p>
        <p>Ved omlasting kan endringer som ikke er lagret gå tapt.</p>
        <button type="button" onClick={() => this.setState({ hasError: false })}>Prøv igjen</button>{" "}
        <button type="button" onClick={() => window.location.reload()}>Last siden på nytt</button>
      </section>;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;